import { useMemo } from 'react';
import { PATH_DASHBOARD, PATH_DEPOSIT, PATH_MASTERDATA } from '../routes/paths';
import Iconify from '../components/iconify';
import { useRole } from './useRole';

export default function useNavConfig() {
    const { isSuperAdmin, isAdmin, isAcconting, isFinance, isOperation, isDirector } = useRole();

    const navConfig = useMemo(() => {
        return [
            {
                subheader: 'MENU',
                items: [
                    {
                        title: 'Dashboard',
                        path: PATH_DASHBOARD.root,
                        icon: <Iconify icon="bi:house-gear" />,
                    },
                    {
                        title: 'Deposit',
                        path: PATH_DEPOSIT.deposit,
                        icon: <Iconify icon="si:wallet-line" />,
                    },
                    {
                        title: 'Master Data',
                        path: PATH_MASTERDATA.root,
                        icon: <Iconify icon="carbon:report" />,
                        children: [
                            ...(isSuperAdmin ? [{
                                title: 'User',
                                path: PATH_MASTERDATA.userAdmin,
                            }] : []),
                            {
                                title: 'Courier',
                                path: PATH_MASTERDATA.user,
                            },
                            {
                                title: 'Site',
                                path: PATH_MASTERDATA.site,
                            },
                            ...(isSuperAdmin || isAdmin || isAcconting || isOperation ? [{
                                title: 'Import',
                                path: PATH_MASTERDATA.import
                            }] : []),
                        ],
                    },
                ],
            },
        ];
    }, [isSuperAdmin, isAdmin]);

    return navConfig;
}